export const formatBrandName = (brandName) => {
    if (!brandName) return '';
    const name = brandName.toLowerCase();

    switch (true) {
        case name.includes('fourhands'):
            return 'Four Hands';
        case name.includes('sunsetwest'):
            return 'Sunset West';
        case name.includes('wayfair'):
            return 'Wayfair';
        case name.includes('dovetail'):
            return 'Dovetail';
        case name.includes('visualcomfort'):
            return 'Visual Comfort';
        case name.includes('curreycompany'):
            return 'Currey & Co';
        default:
            return brandName;
    }
};


export const getFormattedImageLink = (brandName, mainImage, additionalImages) => {

    if (brandName?.includes('fourhands')) {
      let imagesArr = typeof additionalImages === 'string' ? additionalImages.split(',') : [];
      let imageLink = findNextImage(imagesArr, mainImage);        
      return imageLink;
    }

    console.log('mainImage', mainImage);
    
    return mainImage;
}

// if current image string is empty, go to next image
const findNextImage = (images = [], fallback = '') => {
    if (!Array.isArray(images) || images.length === 0) return fallback;
    const [, ...rest] = images;
    const nextImage = rest.find((image) => image && image !== '');
    return nextImage || images[0] || fallback;
}